import { utilSetTimeout } from "./utils/setTimeout";
export default class Tabs {
    tabsElement;
    dom;
    tabs;
    animating;
    constructor(tabsElement) {
        this.tabsElement = tabsElement;
        this.dom = { parent: null, wrapper: null };
        this.tabs = [];
        this.animating = false;
        this.getDomElements();
        if (!this.dom.parent || !this.dom.wrapper) {
            console.warn('Missing "data-wrapper" from the elment wrapping the tabs!');
            return;
        }
        this.init();
    }
    init() {
        this.setTabs();
        this.handleClick();
        this.handleResize();
        this.dom.parent?.classList.add("is-loaded");
    }
    handleClick() {
        this.tabs.forEach((tabItem) => {
            tabItem.key.addEventListener("click", () => {
                if (tabItem.active || this.animating)
                    return;
                this.animateTabs(tabItem);
            });
        });
    }
    handleResize() {
        window.addEventListener("resize", () => {
            this.setTabHeights();
        });
    }
    animateTabs(newTab) {
        let oldTab = this.tabs.find((tab) => tab.active);
        if (!oldTab)
            return;
        this.animating = true;
        this.dom.parent?.classList.add("is-animating");
        this.handleAnimateTabs(newTab, oldTab);
    }
    handleAnimateTabs(newTab, oldTab) {
        if (!this.dom.wrapper)
            return;
        this.dom.wrapper.style.height = `${this.dom.wrapper.offsetHeight}px`;
        utilSetTimeout(() => {
            if (!this.dom.wrapper)
                return;
            this.dom.wrapper.style.height = `${newTab.elementHeight}px`;
            oldTab.key.classList.remove("is-active");
            oldTab.element.classList.remove("is-active");
            oldTab.element.style.opacity = "0";
            newTab.key.classList.add("is-active");
            newTab.element.style.top = "5px";
            newTab.element.style.display = "block";
            newTab.element.style.position = "absolute";
            newTab.element.style.opacity = "0";
        }, 100);
        utilSetTimeout(() => {
            oldTab.active = false;
            newTab.element.style.top = "0";
            newTab.element.style.opacity = "1";
        }, 200 + 110);
        utilSetTimeout(() => {
            if (!this.dom.wrapper)
                return;
            this.dom.wrapper.style.height = "auto";
            oldTab.element.style.display = "none";
            newTab.element.style.position = "relative";
            newTab.element.classList.add("is-active");
            newTab.active = true;
            this.animating = false;
            this.dom.parent?.classList.remove("is-animating");
        }, 200 * 2 - 90);
    }
    setTabs() {
        const keys = this.dom.parent?.querySelectorAll("[data-tabs-key]");
        const tabs = this.dom.parent?.querySelectorAll("[data-tabs-tab]");
        if (!keys || !tabs)
            return;
        keys.forEach((key, index) => {
            let tabElement = tabs[index];
            if (tabElement) {
                if (index == 0) {
                    key.classList.add("is-active");
                    tabElement.classList.add("is-active");
                }
                this.tabs.push({
                    index: index,
                    key: key,
                    element: tabElement,
                    active: index == 0,
                    elementHeight: 0,
                });
            }
        });
        this.setTabHeights();
    }
    setTabHeights() {
        this.tabs.forEach((tabItem) => {
            tabItem.element.style.display = "block";
            tabItem.elementHeight = tabItem.element.offsetHeight;
            tabItem.element.style.display = tabItem.active ? "block" : "none";
        });
    }
    getDomElements() {
        this.dom = {
            parent: this.tabsElement,
            wrapper: this.tabsElement.querySelector("[data-wrapper]"),
        };
    }
}
